export default __webpack_public_path__ + "static/media/AK Logo Dark.68231be8.svg";